// Config por empresa — reaproveita a MESMA fonte que os componentes de init
// (GoogleTagManager / PixelBus / Clarity) usam: state.store.data.empresa.
//
// Lê o store singleton de forma preguiçosa (somente em tempo de execução), o que
// evita problemas de import circular e garante que a empresa já esteja carregada.
import store from "../store";

const empresa = () => {
  try {
    return store.getState()?.store?.data?.empresa || null;
  } catch (e) {
    return null;
  }
};

export const getEmpresa = empresa;

// Dupla guarda: o global existe (ferramenta inicializada pelo componente de init)
// E o id está configurado para a empresa atual. Como o componente só cria o global
// quando o id existe, eventos disparados antes da inicialização caem no early-return.
export const isGtmEnabled = () =>
  !!window.dataLayer &&
  !!(empresa()?.google_tag_manager_id || empresa()?.google_analytics_id);

export const isPixelEnabled = () =>
  typeof window.fbq === "function" && !!empresa()?.pixel_bus_id;

export const isClarityEnabled = () =>
  typeof window.clarity === "function" && !!empresa()?.clarity_id;
